import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const incentiveList = createApi({
  reducerPath: "incentiveList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Incentives"],
  endpoints: (builder) => ({
    getIncentivesData: builder.query({
      query: ({
        page = 1,
        limit,
        type,
        status,
        individual,
        search,
        pagination = true,
        
      }) => ({
        url: `${Apis.incentive}`,
        params: {
          page,
          limit,
          type,
          status,
          individual,
          search,
          pagination, 
        },
      }),
      providesTags: ["Expenses"],
      keepUnusedDataFor: 300,
    }),
  }),
});


export const { useGetIncentivesDataQuery } = incentiveList;


export const teamIncentiveList = createApi({
  reducerPath: "teamIncentiveList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["teamIncentiveList"],
  endpoints: (builder) => ({
    getTeamIncentivesData: builder.query({
      query: ({
        page = 1,
        limit,
        search,
        
      }) => ({
        url: `${Apis.teamIncentive}`,
        params: {
          page,
          limit,
          search, 
        },
      }),
      providesTags: ["teamIncentiveList"],
      keepUnusedDataFor: 300,
    }),
  }),
});


export const { useGetTeamIncentivesDataQuery } = teamIncentiveList;
